import React from 'react'
import { DownloadButton } from './DownloadPdf'

export function cameCaseToSpace(camelCaseString) {
  const rex = /([A-Z])([A-Z])([a-z])|([a-z])([A-Z])/g
  return camelCaseString.replace(rex, '$1$4 $2$3$5')
}

export function parseArrayKey({ path, childProps, arrayIndex }) {
  const replaces = {
    Genitor: 'Nome',
    DisciplinaCursada: 'Disciplina',
    Docente: 'Nome',
  }

  const propToGet = replaces[path]
  const valueInProp = childProps?.[propToGet]?._text

  /**
   *  Remove root from list in root.
   * `root 1` -> `1`
   * `root 2` -> `2`
   */
  const parsedPath = path === "root" ? "" : `${parseName(path)} `

  return valueInProp || `${parsedPath}${1 + parseInt(arrayIndex, 10)}`
}

export function parseName(original) {
  const replaces = {
    'Termo Responsabilidade': 'Termo de Responsabiliade',
    Numero: 'Número',
    'Endereco Curso': 'Endereço do Curso',
    'Codigo Municipio': 'Código do Município',
    'Nome Municipio': 'Nome do Município',
    Endereco: 'Endereço',
    'Codigo EMEC': 'Código EMEC',
    'Codigo Curso EMEC': 'Código do Curso EMEC',
    'Nome Curso': 'Nome do Curso',
    'Titulo Conferido': 'Título Conferido',
    Autorizacao: 'Autorização',
    'Veiculo Publicacao': 'Veículo de Publicação',
    'Data Publicacao': 'Data de Publicação',
    'Secao Publicacao': 'Seção de Publicação',
    'Pagina Publicacao': 'Página de Publicação',
    'Razao Social': 'Razão Social',
    Periodo: 'Período',
    'Data Emissao Historico': 'Data de Emissão do Histórico',
    'Situacao Aluno': 'Situação Aluno',
    'Situacao ENADE': 'Situação ENADE',
    'Carga Horaria Curso Integralizada': 'Carga Horária do Curso Integralizada',
    'Forma Acesso': 'Forma de Acesso',
    'Data Conclusao': 'Data de Conclusão',
    'Ato Designação': 'Ato de Designação',
    'Renovacao Reconhecimento': 'Renovação de Reconhecimento',
    'Renovacao De Recredenciamento': 'Renovação de Recredenciamento',
    'Data Nascimento': 'Data de Nascimento',
    'Ato Designacao': 'Ato de Designação',
    Filiacao: 'Filiação',
    'Historico Escolar': 'Histórico Escolar',
    'Carga Horaria Curso': 'Carga Horária do Curso',
    'Ingresso Curso': 'Ingresso ao Curso',
    'Dados Privados Diplomado': 'Dados Privados do Diplomado',
    'Documentacao Comprobatoria': 'Documentação Comprobatória',
    'Dados Diploma': 'Dados do Diploma',
    Titulacao: 'Titulação',
    Genitor: 'Genitores',
    DisciplinaCursada: 'Disciplinas Cursadas',
    Seguranca: 'Segurança',
    'Id Documentacao Academica': 'ID da Documentação Acadêmica',
    'Responsavel Registro': 'Responsável pelo Registro',
    'Codigo Validacao': 'Código de Validação',
    'Numero Folha Do Diploma': 'Número da Folha Do Diploma',
    'Numero Sequencia Do Diploma': 'Número de Sequencia Do Diploma',
    'Data Expedicao Diploma': 'Data de Expedição do Diploma',
    'I Dou Numero Matricula': 'ID ou Número de Matrícula',
    'Ies Registradora': 'IES Registradora',
    'Ies Emissora': 'IES Emissora',
    'Nome Habilitacao': 'Nome Habilitação',
    'Processo Do Diploma': 'Processo do Diploma',
    'Data Colacao Grau': 'Data Colação de Grau',
    'Número da Folha Do Diploma': 'Número da Folha do Diploma',
    'Número de Sequencia Do Diploma': 'Número de Sequencia do Diploma',
    'Outro Documento Identificacao': 'Outro documento de Identificação',
    Situacao: 'Situação',
  }

  const spaceName = cameCaseToSpace(original)
  return replaces[spaceName] || spaceName
}

/**
 * Receives xmlJson and returns path to the content, like:
 * [ 'ArquivoFiscalizacao', 'infArquivoFiscalizacaoRegistradora' ]
 */
 export const getPrimaryPath = (xmlJson) => {
  const getPrimaryKey = (object) => {
      const entries = Object.entries(object)
      const first = entries.find(([key, value]) => key.charAt(0) !== "_" && !key.includes("Signature"))
      if (!first) return ''
      const firstKey = first[0]
      return firstKey
  }

  const primaryKey = getPrimaryKey(xmlJson)
  if (!primaryKey) return ''
  const firstLayer = xmlJson[primaryKey]
  const secondaryKey = getPrimaryKey(firstLayer)
  if (!secondaryKey) return [primaryKey]
  return [primaryKey, secondaryKey]
}

export function getPrimaryOptions(xmlJson = {}) {
  const [primaryPath, secondaryPath] = getPrimaryPath(xmlJson)
  if (!primaryPath) return {}
  if (!secondaryPath) return xmlJson?.[primaryPath] || {}
  return xmlJson?.[primaryPath]?.[secondaryPath] || {}
}

export function parseLeafValue(text = '', path = '') {
  if (path === 'DadosPrivadosDiplomado.CargaHorariaCurso') return `${text} horas`

  // Parse leaf value the same way of texts of array nodes
  const parsedText = parseText(text, path) // parsed or original

  return parsedText
}

export function parseText(text = '', key = '') {
  function formatCPF(cpf) {
    return cpf.replace(/[^\d]/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  function formatCNPJ(cnpj) {
    return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }

  function formatDate(date) {
    return date.replace(/^(\d{4})-(\d{2})-(\d{2})/, '$3/$2/$1');
  }

  function formatCEP(date) {
    return date.replace(/^(\d{2})(\d{3})(\d{3})/, '$1.$2-$3');
  }

  const keyLowerCase = key.toLowerCase()

  if (keyLowerCase.includes('cpf')) return formatCPF(text)

  if (keyLowerCase.includes('cnpj')) { return formatCNPJ(text) }

  if (keyLowerCase.includes('data')) { return formatDate(text) }

  if (keyLowerCase.includes('cep')) { return formatCEP(text) }

  if (keyLowerCase.includes('atodesignacao')) { return <DownloadButton base64={text} size="small" /> }

  if (keyLowerCase.includes('sexo')) {
    if (text === 'F') return 'Feminino'
    if (text === 'M') return 'Masculino'
  }

  return text
}
